import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: max-content;
  padding: 10px 10px 10px 0px;
  // width: 424px;
  width: ${(props) => props.width || "424px"};
`;

export const MediaContainer = styled.div`
  flex: 1;
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 50vh;
`;
